module.exports = __webpack_public_path__ + "media/packs/booking-system/appointment-booking/src/images/booking-img-step-1-597c68b5074358cd6548e3f8c3a78d40.jpg";